export const XPC_CONSTANTS = {
	SMART_LINKS_XPC_BRIDGE: 'smartLinks',
	QUERY_PARAM: 'xpis',
} as const;
